import { Image } from "@components/Image/Image";
import { Link } from "@components/Link/Link";
import { StyledH4 } from "@components/Styled/Text";
import React from "react";
import {
  ImageGridCardOutputProps,
  withImageGridCard,
} from "./withImageGridCard";

import { clsx } from "clsx";

const styles: any = {
  cols: {
    "1": `w-full`,
    "2": `w-1/2`,
    "3": `w-1/2 md:w-1/3`,
    "4": `w-1/2 md:w-1/4 xl:w-1/4`,
    "5": `w-1/2 md:w-1/4 xl:w-1/5`,
    "6": `w-1/2 md:w-1/4 xl:w-1/6`,
  },
};

const Wrapper = (props: any) => (
  <div
    {...props}
    className={clsx(
      props.className,
      "relative flex flex-col",
      props.spacing && "p-micro sm:p-mini",
      props.cols && styles.cols[props.cols]
        ? styles.cols[props.cols]
        : styles.cols["4"],
      props.textColour === `lightest` ? `text-white` : `text-primary`,
    )}
  />
);

const ImageTitle = (props: any) => (
  <StyledH4
    {...props}
    className={clsx(
      props.className,
      "absolute left-midi top-maxi z-10 cursor-pointer font-display text-h4 md:left-mega md:top-maxi lg:text-[32px]",
    )}
  />
);

const ImageWrapper = (props: any) => (
  <div {...props} className={clsx(props.className, "relative w-full")} />
);

const ImageLinkText = (props: any) => (
  <Link
    {...props}
    className={clsx(
      props.className,
      "absolute bottom-midi left-midi z-10 cursor-pointer border-b font-body text-body leading-body hover:text-white md:bottom-maxi md:left-mega",
    )}
  />
);

const ImageGridCard = withImageGridCard(
  ({
    spacing,
    cols,
    handleClickImage,
    textColour,
    images,
  }: ImageGridCardOutputProps) => (
    <>
      {images.map(({ image, imageLink, imageLinkTitle, imageTitle }, index) => {
        return (
          <Wrapper
            key={index}
            spacing={spacing ? "true" : undefined}
            cols={cols}
            textColour={textColour}
          >
            <ImageWrapper>
              {imageTitle && <ImageTitle role="title">{imageTitle}</ImageTitle>}
              <Image
                image={image}
                alt={image.alt}
                ratio="11/12"
                imageLink={imageLink}
                onClick={handleClickImage}
              />
              {imageLink && (
                <ImageLinkText to={imageLink?.url} role="link">
                  {imageLinkTitle}
                </ImageLinkText>
              )}
            </ImageWrapper>
          </Wrapper>
        );
      })}
    </>
  ),
);

export default ImageGridCard;
